import Vue from 'vue';
import Router from 'vue-router';
import SystemDetailsPage from '../pages/SystemDetailsPage.vue';

// Routes
Vue.use(Router);

export const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/HomePage.vue')
  },
  {
    path: '/comingsoon',
    name: 'comingsoon',
    component: () => import('@/pages/ComingSoonPage.vue')
  },
  {
    path: '/homepage',
    name: 'homepage',
    component: () => import('@/pages/HomePage.vue')
  },
  {
    path: '/venues/:venueName',
    name: 'VenueDetails',
    component: () => import('@/pages/VenueDetailsPage.vue'),
    props: (route) => ({
      data: route.params.data,
      venueName: route.params.venueName
    })
  },
  {
    path: '/venues/:venueName/:systemName',
    name: 'SystemDetails',
    component: SystemDetailsPage,
    props: (route) => ({
      data: route.params.data ? route.params.data : null,
      venueName: route.params.venueName,
      systemName: route.params.systemName
    })
  },
  {
    path: '/venues',
    name: 'venues',
    component: () => import('@/pages/VenuesPage.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/pages/ContactPage.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/pages/TermsPage.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/pages/PrivacyPage.vue')
  },
  {
    path: '/warrantyreturns',
    name: 'warrantyreturns',
    component: () => import('@/pages/WarrantyReturnsPage.vue')
  },
  // Catch-all route should be the last one
  {
    path: '*',
    name: 'SystemDetails',
    component: SystemDetailsPage,
    // Pass the path (or part of it) as a prop to your component
    props: (route) => ({ systemName: route.path.substr(1) })
  }
  // {
  //   path: '*',
  //   name: 'not-found',
  //   component: () => import('@/pages/NotFoundPage.vue')
  // }
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes
});

/**
 * Before each route update
 */
router.beforeEach((to, from, next) => {
  console.log('to', to);
  return next();
});

/**
 * After each route update
 */
router.afterEach(() => {});

export default router;
